import { api } from '../../d1';

export class D1FavoritesRepo {
    async isFavorite(userId: string, listingId: string): Promise<boolean> {
        try {
            if (api.favorites) {
                return await api.favorites.listIds(userId).then(ids => ids.includes(listingId));
            }
            return false;
        } catch { return false; }
    }

    async addFavorite(userId: string, listingId: string): Promise<boolean> {
        try {
            if (api.favorites) {
                await api.favorites.add(userId, listingId);
                return true;
            }
            return false;
        } catch { return false; }
    }

    async removeFavorite(userId: string, listingId: string): Promise<boolean> {
        try {
            if (api.favorites) {
                await api.favorites.remove(userId, listingId);
                return true;
            }
            return false;
        } catch { return false; }
    }

    async getFavorites(userId: string): Promise<string[]> {
        try {
            if (api.favorites) {
                return await api.favorites.listIds(userId);
            }
            return [];
        } catch { return []; }
    }
}
